export const summaryRows: string[] = [
  'Volume 1 — Substation Fundamentals & Layouts',
  'Volume 2 — Primary Equipment',
  'Volume 3 — Protection Principles & Relays',
  'Volume 4 — Grounding, Insulation & Lightning Protection',
  'Volume 5 — Control, Automation & Digital Substations',
  'Volume 6 — Testing, Commissioning & Maintenance',
  'Bonus 1 — ANSI Device Numbers & Protection Functions Quick Reference',
  'Bonus 2 — Single-Line Diagram Reading Guide',
  'Bonus 3 — Protection Coordination Worked Examples',
  'Bonus 4 — Substation Technical Glossary',
  'Bonus 5 — Protection & Control Interview Preparation Guide',
  '7-day money-back guarantee',
  'Instant access',
];
